import { stringPadStart } from '@dazn/peng-html5-tools-utils';
import { COR } from "../../Shared/Constants/PackageNamespace";
/**
 * Takes the message params `packageNamespace` and `featureNumber` (e.g. 'COR' and 4) and returns
 * the full corresponding feature ID (e.g. `COR_004_FOO`), by reflecting on the provided
 * `messages` table.
 */
var getFeatureIdFromMessageParams = function (packageNamespace, featureNumber, messages) {
    if (packageNamespace === COR && featureNumber === 0)
        return "_"; // "core" / built-in messages
    var featureNamePrefix = "".concat(packageNamespace, "_").concat(stringPadStart(featureNumber.toString(), 3, '0'));
    for (var featureName in messages) {
        if (featureName.indexOf(featureNamePrefix) !== 0)
            continue;
        return featureName;
    }
    // NB: The error manager is NOT used here because we are already in the debug chunk and message
    // rendering is already broken at this stage, so the best DX is to throw an exception with a
    // hard-coded message.
    throw new Error("No feature name could be found in the lookup table with the prefix \"".concat(featureNamePrefix, "\""));
};
export { getFeatureIdFromMessageParams as getFeatureIdFromMessageParams };
//# sourceMappingURL=getFeatureNameFromMessageParams.js.map